/** storage screen strings (EN source of truth + VI); spread into the main dictionaries */

export const storageEn = {
  'storage.title': 'Storage',
  'storage.subtitle': 'Files and images for your workspace, organised in folders. Agents can find them through their descriptions and summaries.',
  'storage.root': 'Storage',
  'storage.allFiles': 'All files',
  'storage.folders': 'Folders',
  'storage.files': 'Files',
  'storage.items': 'Folders and files',
  'storage.browser': 'Folder contents',
  'storage.path': 'Folder path',
  'storage.empty': 'This folder is empty.',
  'storage.emptyHint': 'Upload files or drop them anywhere on this page.',
  'storage.emptyFiltered': 'Nothing here matches the filter.',
  'storage.loadMore': 'Load more',
  'storage.backToRoot': 'Back to Storage',

  'storage.filter.label': 'Filter by name',
  'storage.filter.placeholder': 'Filter by name…',
  'storage.view.label': 'View',
  'storage.view.grid': 'Grid view',
  'storage.view.list': 'List view',

  'storage.error.generic': 'Something went wrong: {message}',
  'storage.error.folders': 'Could not load folders.',
  'storage.error.files': 'Could not load files.',
  'storage.error.folderMissing': 'This folder does not exist or was deleted.',

  'storage.folder.new': 'New folder',
  'storage.folder.newTopLevel': 'New top-level folder',
  'storage.folder.newSubfolder': 'New subfolder',
  'storage.folder.name': 'Folder name',
  'storage.folder.nameRequired': 'Enter a folder name.',
  'storage.folder.subfolderNameIn': 'New subfolder name in {name}',
  'storage.folder.createdIn': 'It will be created in {name}.',
  'storage.folder.create': 'Create folder',
  'storage.folder.creating': 'Creating…',
  'storage.folder.created': 'Folder "{name}" created',
  'storage.folder.rename': 'Rename',
  'storage.folder.delete': 'Delete folder',
  'storage.folder.deleteTitle': 'Delete folder',
  'storage.folder.deleteConfirm': 'Delete "{name}" and its subfolders? Files inside are kept and moved to the top level of Storage.',
  'storage.folder.deleted': 'Folder "{name}" deleted',
  'storage.folder.openNamed': 'Open folder {name}',
  'storage.folder.actionsNamed': 'Actions for {name}',
  'storage.folder.expandNamed': 'Expand {name}',
  'storage.folder.collapseNamed': 'Collapse {name}',
  'storage.folder.empty': 'Empty',
  'storage.folder.subfolderOne': '{count} subfolder',
  'storage.folder.subfolderMany': '{count} subfolders',
  'storage.folder.fileOne': '{count} file',
  'storage.folder.fileMany': '{count} files',

  'storage.file.download': 'Download',
  'storage.file.downloadNamed': 'Download {name}',
  'storage.file.copyLink': 'Copy link',
  'storage.file.copyLinkNamed': 'Copy link to {name}',
  'storage.file.linkCopied': 'Link copied',
  'storage.file.copyFailed': 'Could not copy the link',
  'storage.file.delete': 'Delete file',
  'storage.file.deleteNamed': 'Delete {name}',
  'storage.file.deleteTitle': 'Delete file',
  'storage.file.deleteConfirm': 'Delete "{name}" permanently? Links to it will stop working.',
  'storage.file.deleted': '"{name}" deleted',
  'storage.delete.deleting': 'Deleting…',

  'storage.select.all': 'Select all',
  'storage.select.named': 'Select {name}',
  'storage.bulk.label': 'Selected items',
  'storage.bulk.selected': '{count} selected',
  'storage.bulk.move': 'Move to folder',
  'storage.bulk.delete': 'Delete',
  'storage.bulk.clear': 'Clear selection',
  'storage.bulk.moved': 'Moved {count} item(s) to {name}',
  'storage.bulk.deleted': 'Deleted {count} item(s)',
  'storage.bulk.deleteTitle': 'Delete {count} item(s)?',
  'storage.bulk.deleteFiles': 'The selected files are deleted permanently and their links stop working.',
  'storage.bulk.deleteWithFolders': 'Selected files are deleted permanently. Selected folders are deleted with their subfolders; files inside them are kept and moved to the top level of Storage.',

  'storage.move.title': 'Move {count} item(s)',
  'storage.move.target': 'Destination folder',
  'storage.move.alreadyHere': 'The items are already in this folder.',
  'storage.move.submit': 'Move',
  'storage.move.moving': 'Moving…',

  'storage.upload.button': 'Upload',
  'storage.upload.pick': 'Choose files to upload',
  'storage.upload.title': 'Upload files',
  'storage.upload.destination': 'Files go into {name}.',
  'storage.upload.descriptionHint': 'Describe each file in a sentence. Agents use the description to find the right file.',
  'storage.upload.descriptionFor': 'Description for {name}',
  'storage.upload.descriptionPlaceholder': 'e.g. Signed vendor contract for the 2026 hosting renewal',
  'storage.upload.descriptionRequired': 'Add a description.',
  'storage.upload.descriptionTooLong': 'Keep the description under {max} characters.',
  'storage.upload.descriptionGeneric': 'Be more specific than a generic word like "file" or "image".',
  'storage.upload.tooLarge': '{count} file(s) are over the 100 MB limit and will be skipped:',
  'storage.upload.submit': 'Upload {count} file(s)',
  'storage.upload.done': 'Uploaded {count} file(s)',
  'storage.upload.someFailed': '{count} upload(s) failed. See the upload list for details.',
  'storage.upload.failed': 'Upload failed',
  'storage.upload.failedStatus': 'Upload failed ({status})',
  'storage.upload.networkError': 'Network error',
  'storage.upload.progressList': 'Uploads in progress',
  'storage.upload.progressNamed': 'Upload progress for {name}',
  'storage.upload.dismissNamed': 'Dismiss {name}',

  'storage.drop.title': 'Drop files to upload',
  'storage.drop.hint': 'They go into {name}. You will add a description before the upload starts.',

  'storage.preview.openNamed': 'Preview {name}',
  'storage.preview.previous': 'Previous file',
  'storage.preview.next': 'Next file',
  'storage.preview.position': '{current} of {total}',

  'storage.description.label': 'File description',
  'storage.description.add': 'Add description',
  'storage.description.edit': 'Edit description',
  'storage.description.placeholder': '+ Add description',
  'storage.description.charsLeft': '{count} left',
  'storage.description.saveFailed': 'Description not saved: {message}',

  'storage.summary.generate': 'Generate summary',
  'storage.summary.generating': 'Generating summary…',
  'storage.summary.regenerate': 'Regenerate summary',
  'storage.summary.regenerating': 'Regenerating…',
  'storage.summary.waitForExtraction': 'Available once text extraction finishes',
  'storage.summary.cooldown': 'Try again in {seconds}s',
  'storage.summary.regenerateFailed': 'Could not regenerate the summary: {message}',
  'storage.summary.expand': 'Show more',
  'storage.summary.collapse': 'Show less',

  'storage.extraction.pending': 'Pending',
  'storage.extraction.processing': 'Extracting…',
  'storage.extraction.completed': 'Indexed',
  'storage.extraction.failed': 'Failed',
  'storage.extraction.unsupported': 'Not indexed',
  'storage.extraction.retry': 'Retry extraction',
  'storage.extraction.retryFailed': 'Extraction retry failed: {message}',
  'storage.extraction.excluded': 'Kept out of AI',

  'storage.memes': 'Memes',
  'storage.memes.subtitle': 'Images and GIFs just for fun. AI never reads memes: no text extraction, no summaries, no search results, and never in an agent\'s context.',
  'storage.memes.search.label': 'Search memes',
  'storage.memes.search.placeholder': 'Search by name or description…',
  'storage.memes.empty': 'No memes yet.',
  'storage.memes.emptyHint': 'Upload images or GIFs here, or turn an existing file into a meme with its meme button.',
  'storage.memes.noMatch': 'No meme matches the search.',
  'storage.file.addMeme': 'Add to memes',
  'storage.file.addMemeNamed': 'Add {name} to memes',
  'storage.file.removeMeme': 'Remove from memes',
  'storage.file.removeMemeNamed': 'Remove {name} from memes',
  'storage.file.memeAdded': '"{name}" is now a meme: AI and search will not see it',
  'storage.file.addMemeConfirm': 'Make "{name}" a meme? Its extracted text, AI summary, and search index are deleted, and AI and search will no longer see it.',
  'storage.file.removeMemeConfirm': 'Take "{name}" out of the memes? It will be extracted, summarized, and searchable again, and agents can read it.',
  'storage.file.memeRemoved': '"{name}" left the memes and will be indexed again',
} satisfies Record<string, string>

export const storageVi: Record<keyof typeof storageEn, string> = {
  'storage.title': 'Lưu trữ',
  'storage.subtitle': 'Tệp và hình ảnh của không gian làm việc, sắp xếp theo thư mục. Agent tìm thấy chúng nhờ mô tả và bản tóm tắt.',
  'storage.root': 'Lưu trữ',
  'storage.allFiles': 'Tất cả tệp',
  'storage.folders': 'Thư mục',
  'storage.files': 'Tệp',
  'storage.items': 'Thư mục và tệp',
  'storage.browser': 'Nội dung thư mục',
  'storage.path': 'Đường dẫn thư mục',
  'storage.empty': 'Thư mục này đang trống.',
  'storage.emptyHint': 'Tải tệp lên hoặc kéo thả vào bất kỳ đâu trên trang này.',
  'storage.emptyFiltered': 'Không có mục nào khớp bộ lọc.',
  'storage.loadMore': 'Tải thêm',
  'storage.backToRoot': 'Quay lại Lưu trữ',

  'storage.filter.label': 'Lọc theo tên',
  'storage.filter.placeholder': 'Lọc theo tên…',
  'storage.view.label': 'Kiểu hiển thị',
  'storage.view.grid': 'Dạng lưới',
  'storage.view.list': 'Dạng danh sách',

  'storage.error.generic': 'Đã xảy ra lỗi: {message}',
  'storage.error.folders': 'Không tải được danh sách thư mục.',
  'storage.error.files': 'Không tải được danh sách tệp.',
  'storage.error.folderMissing': 'Thư mục này không tồn tại hoặc đã bị xóa.',

  'storage.folder.new': 'Thư mục mới',
  'storage.folder.newTopLevel': 'Thư mục cấp cao nhất mới',
  'storage.folder.newSubfolder': 'Thư mục con mới',
  'storage.folder.name': 'Tên thư mục',
  'storage.folder.nameRequired': 'Hãy nhập tên thư mục.',
  'storage.folder.subfolderNameIn': 'Tên thư mục con mới trong {name}',
  'storage.folder.createdIn': 'Thư mục sẽ được tạo trong {name}.',
  'storage.folder.create': 'Tạo thư mục',
  'storage.folder.creating': 'Đang tạo…',
  'storage.folder.created': 'Đã tạo thư mục "{name}"',
  'storage.folder.rename': 'Đổi tên',
  'storage.folder.delete': 'Xóa thư mục',
  'storage.folder.deleteTitle': 'Xóa thư mục',
  'storage.folder.deleteConfirm': 'Xóa "{name}" cùng các thư mục con? Tệp bên trong vẫn được giữ và chuyển ra cấp cao nhất của Lưu trữ.',
  'storage.folder.deleted': 'Đã xóa thư mục "{name}"',
  'storage.folder.openNamed': 'Mở thư mục {name}',
  'storage.folder.actionsNamed': 'Thao tác cho {name}',
  'storage.folder.expandNamed': 'Mở rộng {name}',
  'storage.folder.collapseNamed': 'Thu gọn {name}',
  'storage.folder.empty': 'Trống',
  'storage.folder.subfolderOne': '{count} thư mục con',
  'storage.folder.subfolderMany': '{count} thư mục con',
  'storage.folder.fileOne': '{count} tệp',
  'storage.folder.fileMany': '{count} tệp',

  'storage.file.download': 'Tải xuống',
  'storage.file.downloadNamed': 'Tải xuống {name}',
  'storage.file.copyLink': 'Sao chép liên kết',
  'storage.file.copyLinkNamed': 'Sao chép liên kết tới {name}',
  'storage.file.linkCopied': 'Đã sao chép liên kết',
  'storage.file.copyFailed': 'Không sao chép được liên kết',
  'storage.file.delete': 'Xóa tệp',
  'storage.file.deleteNamed': 'Xóa {name}',
  'storage.file.deleteTitle': 'Xóa tệp',
  'storage.file.deleteConfirm': 'Xóa vĩnh viễn "{name}"? Các liên kết tới tệp sẽ không còn hoạt động.',
  'storage.file.deleted': 'Đã xóa "{name}"',
  'storage.delete.deleting': 'Đang xóa…',

  'storage.select.all': 'Chọn tất cả',
  'storage.select.named': 'Chọn {name}',
  'storage.bulk.label': 'Các mục đã chọn',
  'storage.bulk.selected': 'Đã chọn {count}',
  'storage.bulk.move': 'Chuyển vào thư mục',
  'storage.bulk.delete': 'Xóa',
  'storage.bulk.clear': 'Bỏ chọn',
  'storage.bulk.moved': 'Đã chuyển {count} mục vào {name}',
  'storage.bulk.deleted': 'Đã xóa {count} mục',
  'storage.bulk.deleteTitle': 'Xóa {count} mục?',
  'storage.bulk.deleteFiles': 'Các tệp đã chọn sẽ bị xóa vĩnh viễn và liên kết tới chúng sẽ không còn hoạt động.',
  'storage.bulk.deleteWithFolders': 'Các tệp đã chọn sẽ bị xóa vĩnh viễn. Các thư mục đã chọn bị xóa cùng thư mục con; tệp bên trong vẫn được giữ và chuyển ra cấp cao nhất của Lưu trữ.',

  'storage.move.title': 'Chuyển {count} mục',
  'storage.move.target': 'Thư mục đích',
  'storage.move.alreadyHere': 'Các mục đã nằm trong thư mục này.',
  'storage.move.submit': 'Chuyển',
  'storage.move.moving': 'Đang chuyển…',

  'storage.upload.button': 'Tải lên',
  'storage.upload.pick': 'Chọn tệp để tải lên',
  'storage.upload.title': 'Tải tệp lên',
  'storage.upload.destination': 'Tệp sẽ được lưu vào {name}.',
  'storage.upload.descriptionHint': 'Mô tả mỗi tệp bằng một câu. Agent dựa vào mô tả để tìm đúng tệp.',
  'storage.upload.descriptionFor': 'Mô tả cho {name}',
  'storage.upload.descriptionPlaceholder': 'Ví dụ: Hợp đồng nhà cung cấp đã ký cho đợt gia hạn hosting năm 2026',
  'storage.upload.descriptionRequired': 'Hãy thêm mô tả.',
  'storage.upload.descriptionTooLong': 'Mô tả không được dài quá {max} ký tự.',
  'storage.upload.descriptionGeneric': 'Hãy mô tả cụ thể hơn một từ chung chung như "file" hay "image".',
  'storage.upload.tooLarge': '{count} tệp vượt giới hạn 100 MB và sẽ bị bỏ qua:',
  'storage.upload.submit': 'Tải lên {count} tệp',
  'storage.upload.done': 'Đã tải lên {count} tệp',
  'storage.upload.someFailed': '{count} tệp tải lên không thành công. Xem chi tiết trong danh sách tải lên.',
  'storage.upload.failed': 'Tải lên không thành công',
  'storage.upload.failedStatus': 'Tải lên không thành công ({status})',
  'storage.upload.networkError': 'Lỗi kết nối mạng',
  'storage.upload.progressList': 'Các tệp đang tải lên',
  'storage.upload.progressNamed': 'Tiến độ tải lên {name}',
  'storage.upload.dismissNamed': 'Ẩn {name}',

  'storage.drop.title': 'Thả tệp để tải lên',
  'storage.drop.hint': 'Tệp sẽ được lưu vào {name}. Bạn sẽ thêm mô tả trước khi bắt đầu tải lên.',

  'storage.preview.openNamed': 'Xem trước {name}',
  'storage.preview.previous': 'Tệp trước',
  'storage.preview.next': 'Tệp tiếp theo',
  'storage.preview.position': '{current} / {total}',

  'storage.description.label': 'Mô tả tệp',
  'storage.description.add': 'Thêm mô tả',
  'storage.description.edit': 'Sửa mô tả',
  'storage.description.placeholder': '+ Thêm mô tả',
  'storage.description.charsLeft': 'Còn {count} ký tự',
  'storage.description.saveFailed': 'Chưa lưu được mô tả: {message}',

  'storage.summary.generate': 'Tạo bản tóm tắt',
  'storage.summary.generating': 'Đang tạo bản tóm tắt…',
  'storage.summary.regenerate': 'Tạo lại bản tóm tắt',
  'storage.summary.regenerating': 'Đang tạo lại…',
  'storage.summary.waitForExtraction': 'Dùng được sau khi trích xuất nội dung xong',
  'storage.summary.cooldown': 'Thử lại sau {seconds} giây',
  'storage.summary.regenerateFailed': 'Không tạo lại được bản tóm tắt: {message}',
  'storage.summary.expand': 'Xem thêm',
  'storage.summary.collapse': 'Thu gọn',

  'storage.extraction.pending': 'Đang chờ',
  'storage.extraction.processing': 'Đang trích xuất…',
  'storage.extraction.completed': 'Đã lập chỉ mục',
  'storage.extraction.failed': 'Thất bại',
  'storage.extraction.unsupported': 'Không lập chỉ mục',
  'storage.extraction.retry': 'Thử trích xuất lại',
  'storage.extraction.retryFailed': 'Thử trích xuất lại không thành công: {message}',
  'storage.extraction.excluded': 'Không đưa vào AI',

  'storage.memes': 'Meme',
  'storage.memes.subtitle': 'Ảnh và GIF chỉ để giải trí. AI không bao giờ đọc meme: không trích xuất văn bản, không tóm tắt, không xuất hiện trong kết quả tìm kiếm và không bao giờ vào ngữ cảnh của agent.',
  'storage.memes.search.label': 'Tìm meme',
  'storage.memes.search.placeholder': 'Tìm theo tên hoặc mô tả…',
  'storage.memes.empty': 'Chưa có meme nào.',
  'storage.memes.emptyHint': 'Tải ảnh hoặc GIF lên đây, hoặc biến một tệp có sẵn thành meme bằng nút meme của tệp.',
  'storage.memes.noMatch': 'Không có meme nào khớp với tìm kiếm.',
  'storage.file.addMeme': 'Thêm vào meme',
  'storage.file.addMemeNamed': 'Thêm {name} vào meme',
  'storage.file.removeMeme': 'Bỏ khỏi meme',
  'storage.file.removeMemeNamed': 'Bỏ {name} khỏi meme',
  'storage.file.memeAdded': '"{name}" đã thành meme: AI và tìm kiếm sẽ không thấy tệp này',
  'storage.file.addMemeConfirm': 'Biến "{name}" thành meme? Văn bản đã trích xuất, bản tóm tắt AI và chỉ mục tìm kiếm của tệp sẽ bị xoá, AI và tìm kiếm sẽ không còn thấy tệp này.',
  'storage.file.removeMemeConfirm': 'Bỏ "{name}" khỏi meme? Tệp sẽ được trích xuất, tóm tắt và tìm kiếm được trở lại, và agent có thể đọc tệp này.',
  'storage.file.memeRemoved': '"{name}" đã rời khỏi meme và sẽ được lập chỉ mục lại',
}
